import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Icon,
  SimpleGrid,
  useBreakpointValue,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { MdCheckCircle } from 'react-icons/md';

const MotionBox = motion(Box);

/**
 * Workshop Outcomes Section
 * Displays learning outcomes and key takeaways
 */
const WorkshopOutcomes = ({ workshop }) => {
  const gridCols = useBreakpointValue({ base: 1, md: 2, lg: 3 });

  if (!workshop?.outcomes || workshop.outcomes.length === 0) return null;

  const { outcomes } = workshop;

  return (
    <Box py={{ base: 16, md: 20 }} bg="white">
      <Container maxW="container.lg">
        {/* Header */}
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          mb={{ base: 12, md: 16 }}
        >
          <VStack align="center" spacing={3} textAlign="center">
            <Heading as="h2" size="xl" fontWeight="900" color="gray.900">
              What You'll Learn
            </Heading>
            <Text fontSize="lg" color="gray.600" maxW="2xl">
              Key outcomes and skills you'll gain from this workshop
            </Text>
          </VStack>
        </MotionBox>

        {/* Outcomes Grid */}
        <SimpleGrid columns={gridCols} spacing={8}>
          {outcomes.map((outcome, idx) => (
            <MotionBox
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
            >
              <HStack align="start" spacing={4}>
                <Icon
                  as={MdCheckCircle}
                  w={6}
                  h={6}
                  color="green.500"
                  flexShrink={0}
                  mt={1}
                />
                <Text color="gray.700" fontSize="md" lineHeight="1.6">
                  {outcome}
                </Text>
              </HStack>
            </MotionBox>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default WorkshopOutcomes;
